import React, { useEffect, useRef } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.scss';
import { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import Loader from '@Components/loader/Loader';
import Layout from './features/layout';
import { useAppDispatch, useAppSelector } from './app/hooks';
import FloatingChat from '@Components/FloatingChat/FloatingChat';
import { clearUserData } from '@Src/app/reducers/auth/loginSlice';
import { clearCoursePreferences } from '@Src/app/reducers/auth/coursePreferencesSlice';
import i18n from './i18n';
import { AppRouteURL, AppRouteURLwithChilds } from '@Constants/app-route-url.constant';


const App: React.FC = () => {
	const isSpinnerVisible = useAppSelector(state => state.global);
	const dispatch = useAppDispatch();
	const isLoggedIn = useAppSelector(state => state.login.isLoggedIn);
	const language = useAppSelector((state) => state.login.LanguageName);
	const location = useLocation();
	const previousPathname = useRef(location.pathname);
	const verifyOtpPath = `${AppRouteURL.AUTH}${AppRouteURLwithChilds.AUTH.childrens.VERIFY_MOBILE_REG_OTP.path}`;

	useEffect(() => {
		const wasOnVerifyOtpPage = previousPathname.current === verifyOtpPath;
		const isOnVerifyOtpPage = location.pathname === verifyOtpPath;

		if (wasOnVerifyOtpPage && !isOnVerifyOtpPage) {
			localStorage.removeItem('resend_count');
		}

		previousPathname.current = location.pathname;
	}, [location.pathname, verifyOtpPath]);

	useEffect(() => {
		const handleStorageChange = (e: StorageEvent) => {
			if (e.key === 'persist:root') {
				try {
					const newState = JSON.parse(e.newValue || '{}');
					const loginState = JSON.parse(newState.login || '{}');
					if (isLoggedIn && loginState.isLoggedIn === false) {
						window.location.reload();
					} else if (!isLoggedIn && loginState.isLoggedIn === true) {
						window.location.reload();
					}
				} catch (error) {
					console.error("Error parsing storage change:", error);
				}
			}
		};

		window.addEventListener('storage', handleStorageChange);
		return () => window.removeEventListener('storage', handleStorageChange);
	}, [isLoggedIn, dispatch]);

	useEffect(() => {

		if (language === "English") {
			i18n.changeLanguage("en");
		} else if (language === "Hindi") {
			i18n.changeLanguage("hi");
		} else if (language === "Bengali") {
			i18n.changeLanguage("bn");
		} else if (language === "Telugu") {
			i18n.changeLanguage("te");
		} else if (language === "Tamil") {
			i18n.changeLanguage("ta");
		} else if (language === "Marathi") {
			i18n.changeLanguage("mr");
		} else if (language === "Gujarati") {
			i18n.changeLanguage("gu");
		}
	}, [language]);

	useEffect(() => {
		if (process.env.NODE_ENV === 'production') {
			console.log = () => { };
			console.warn = () => { };
			console.error = () => { };
		}
	}, [window.location])

	return (
		<div>
			<Routes>
				<Route path='/*' element={<Layout />} />
			</Routes>
			<FloatingChat />
			{isSpinnerVisible.loading ? <Loader /> : null}
			<div>
				<div>
					<Toaster
						position="top-center"
						reverseOrder={false}
						toastOptions={{
							duration: 6000
						}}
					/>
				</div>
			</div>
		</div>
	);
}

export default App;
